module.exports = __webpack_public_path__ + "static/media/user-rupee.761f34e4.svg";